export interface ConversationSummary {
  publicId: string
  userEmail: string
  userName: string
  messageCount: number
  hubContextId: string | null
  viewContextId: string | null
  documentContextId: string | null
  createdAt: string
  updatedAt: string
}

export interface ConversationMessageTool {
  publicId: string
  skillId: string
  arguments: Record<string, any> | null
  output: Record<string, any> | null
  implemented: boolean | null
  error: Record<string, any> | null
}

export interface ConversationMessage {
  publicId: string
  role: string
  content: string
  thinking?: string
  tools?: ConversationMessageTool[]
  vote?: number
  feedback?: string
  createdAt: string
}

export interface ConversationDetail extends ConversationSummary {
  messages: ConversationMessage[]
}

export const SKILL_LABELS: Record<string, string> = {
  audit_logs: 'Audit Logs',
  template_schema_search: 'Template Search',
  template_document_search: 'Template Search',
  support_access: 'Support Access',
  debug_error_lookup: 'Error Lookup',
  formula_helper: 'Formula Helper'
}
